<template>
  <BaseIcon v-bind="$attrs">
    <template #svg>
      <SvgIcon />
    </template>
  </BaseIcon>
</template>

<script>
import SvgIcon from '@material-design-icons/svg/outlined/warning_amber.svg';
import BaseIcon from './BaseIcon.vue';

export default {
  name: 'IconWarningAmber',
  components: {
    BaseIcon,
    SvgIcon,
  },
};
</script>
